var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTlLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 4",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "topGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffd5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00ccaa",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sideGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ccaa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#008c7a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "depthGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#66ffeb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00e6c3",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    transform: "translate(0.1, 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.2 0.2 V 0.7 H 1.2 V 2.2 H 1.7 V 0.2 Z M 2.2 0.2 H 2.7 V 0.7 H 2.2 V 0.2 Z M 3.2 0.2 V 2.2 H 4.7 V 1.7 H 3.7 V 0.2 H 3.2 Z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#sideGradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 0 L 1.1 0 L 1.1 2 L 1 2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 0 L 1.6 0 L 1.6 2 L 1.5 2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 0 L 3.1 0 L 3.1 2 L 3 2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 0 L 3.6 0 L 3.6 2 L 3.5 2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.5 1.5 L 4.6 1.5 L 4.6 2 L 4.5 2 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#topGradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 V 0.5 H 1 V 2 H 1.5 V 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 0 H 2.5 V 0.5 H 2 V 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 0 V 2 H 4.5 V 1.5 H 3.5 V 0 H 3 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#depthGradient)",
    strokeWidth: 0.04,
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.5 H 1 M 1 0 V 2 M 1.5 0 V 2 M 3 0 V 2 M 3.5 0 V 2 M 3 2 H 4.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlLogo);
export default __webpack_public_path__ + "static/media/TLLogo.fd1e0eb5da24d2ca98102d3e1304d827.svg";
export { ForwardRef as ReactComponent };